<template>
	<div class="col-4 col-button">
		<router-link :to="{ name: routerLink, params: { categories: ( categories != null ? categories.join(',') : '' ), id: routerID } }">
			<div class="button d-flex flex-column " :style="style">
				<div class="inner my-auto">
					<h1 class="text-center">{{ title }}</h1>
					<div class="text">
						<p>
							{{ text }}
						</p>
					</div>
				</div>
			</div>
		</router-link>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
	name: "StartScreenButton",
	props: {
		title: String,
		text: String,
		link: String,
		categories: Array,
		article: String,
		index: Number,
		totalButtons: Number,
	},
	computed: {
		style() {
			return `background-color: ${this.index % 2 == 0 ? "#fff" : "#fff"};`;
		},
		routerLink() {
			if (this.article != null) {
				return "Article";
			}

			return this.link;
		},
		routerCategories() {
			return categories != null ? categories.join(",") : "";
		},
		routerID() {
			const { t, te, tm } = useI18n();

			if (this.article != null && this.link == "ArticleOverview") {
				if (te("article")) {
					for (let i = 0; i < tm("article").length; i++) {
						if (t(`article[${i}].post_id`) == this.article) {
							return i;
						}
					}
				}
			}
			return "";
		},
		buttonWidth() {
			if(this.totalButtons <= 6)
			{	
				return '500px';
			} else {
				return '416px';
			}
		},
		buttonHeight() {
			if(this.totalButtons <= 6)
			{	
				return '274px';
			} else {
				return '228px';
			}
		},
		h1Size()
		{
			if(this.totalButtons <= 6)
			{	
				return '48px';
			} else {
				return '39px';
			}
		},
		pSize()
		{
			if(this.totalButtons <= 6)
			{	
				return '20px';
			} else {
				return '16px';
			}
		}
	},
};
</script>

<style scoped>

.col-button {
	max-width: v-bind(buttonWidth);
	margin: 16px 35px;
}

.button {
	width: v-bind(buttonWidth);
	height: v-bind(buttonHeight);
	border-radius: 5px;
	padding: 25px;
	filter: drop-shadow(6px 6px 5px rgba( 43, 4, 78, 0.16 ));
}

.inner h1 {
	font-size: v-bind(h1Size);
	font-weight: bold;
	margin-top: 26px;
	color: #000;
}
 
.inner p {
	font-size: v-bind(pSize);
	line-height: 1;
	font-weight: normal;
	color: #000;
	text-align: center;
}

.text {
	margin: 0 20px;
}
</style>